import { useMutation } from '@apollo/client'
import gql from 'graphql-tag'
import { ExistingProfileInput, ProfileMutationOutput } from 'epc-schema'

/**
 * This mutation will update the user's profile upon
 * form submission.
 */
const UPDATE_PROFILE_MUTATION = gql`
  mutation UpdateProfile($profileInput: ExistingProfileInput!) {
    response: updateProfile(profileInput: $profileInput) {
      profile {
        ... on Profile {
          id
          about
          avatarUrl
          bio
          color
          firstName
          lastName
          emailAddress
          phone
          contentAreas
          about
          keywords
          connectionPreference
          gradeLevels
          otherSecondaryLanguages
          secondaryLanguages
          role
        }
        ... on Educator {
          districtId
          districtName
          schoolId
          schoolName
        }
        ... on Professional {
          cities
          preferredActivities
          companyName
          contentAreaJobFields
          jobFieldLowerLevels
          jobField
        }
      }
      errors {
        message
        path
      }
      success
    }
  }
`

export const useUpdateProfile = () =>
  useMutation<
    { response: ProfileMutationOutput },
    { profileInput: ExistingProfileInput }
  >(UPDATE_PROFILE_MUTATION)
